import { createAction } from "./actionCreators";

const [useDismissUploads, dismissUploads] = createAction("uploads/dismiss");

export default useDismissUploads;
export { dismissUploads };
